import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METABASE_API_URL, metabaseApi } from '../../core/api';
import { QUERY_KEY_CARD, QUERY_KEY_CARD_QUERY } from './useCardData';

export type UpdateCardProps = {
  id: number;
  payload: unknown;
};

export const useUpdateCard = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, payload }: UpdateCardProps) => {
      const response = await metabaseApi.put(
        `${METABASE_API_URL}/card/${id}`,
        payload
      );
      // oxlint-disable-next-line @typescript-eslint/no-unsafe-return
      return response.data;
    },
    onSuccess: async (_, { id }) => {
      // Invalidate and WAIT for refetch to complete before returning
      // This ensures cache has new data before preview states are cleared
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_CARD, id],
        }),
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_CARD_QUERY, id],
        }),
      ]);
    },
  });
};
